import { render, staticRenderFns } from "./HistoricoAnalisadores.vue?vue&type=template&id=298b0288&scoped=true"
import script from "./HistoricoAnalisadores.vue?vue&type=script&lang=js"
export * from "./HistoricoAnalisadores.vue?vue&type=script&lang=js"
import style0 from "./HistoricoAnalisadores.vue?vue&type=style&index=0&id=298b0288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b0288",
  null
  
)

export default component.exports